import { GET_FEEDBACK_LIST, GET_FEEDBACK_LIST_SUCCESS, GET_FEEDBACK_LIST_ERROR, GET_FEEDBACK_LIST_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetFeedbackList = (state = initialState, action) => {
  switch (action.type) {
    case GET_FEEDBACK_LIST:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_FEEDBACK_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_FEEDBACK_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_FEEDBACK_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetFeedbackList;
